import React, { useState, useEffect, useContext } from "react";

import api, { API_URL, AuthContext, BACKEND_URL } from "./util/api";
import { useNavigate } from "react-router-dom";

export default function MembersPage() {

  const { token, User } = useContext(AuthContext);
  const navigate = useNavigate();

  const [selectedMember, setSelectedMember] = useState(null);
  const [loadedImages, setLoadedImages] = useState({});
  const [members, setMembers] = useState([]);

  const [loading, setLoading] = useState(true);

  // ✅ Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);

  // ✅ Search
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  useEffect(() => {
    if (token === "" || token === null || User == null || User === "") {
      navigate("/login");
    }
  }, []);

  // ✅ Debounce (smooth typing)
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
      setCurrentPage(1); // reset to first page
    }, 500);

    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    fetchMembers(currentPage);
  }, [currentPage, debouncedSearch]);

  const fetchMembers = async (page = 1) => {

    setLoading(true);

    try {
      const res = await api.get(
        `${API_URL}/members?page=${page}&per_page=8&search=${debouncedSearch}`
      );

      if (res.data.status) {
        setMembers(res.data.members);
        setCurrentPage(res.data.pagination.current_page);
        setLastPage(res.data.pagination.last_page);
      }

    } catch (error) {
      console.log(error);
    }

    setLoading(false);
  };

  const closeZoom = (e) => {
    if (e.target.className === "zoom-overlay") {
      setSelectedMember(null);
    }
  };

  const goToPage = (page) => {
    if (page >= 1 && page <= lastPage) {
      setCurrentPage(page);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <>
      {/* 🔍 PREMIUM SEARCH BAR */}


      {selectedMember && (
        <div className="zoom-overlay" onClick={closeZoom} style={styles.overlay}>
          <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
            <button onClick={() => setSelectedMember(null)} style={styles.closeBtn}>✕</button>

            <img
              src={BACKEND_URL + selectedMember.picture}
              alt={selectedMember.name}
              style={styles.modalImg}
            />

            <h2>{selectedMember.name}</h2>
            <h3 style={{ color: "#777" }}>{selectedMember.position}</h3>

            <p>{selectedMember.bio || "No additional information available."}</p>

            {selectedMember.email && <p><strong>Email:</strong> {selectedMember.email}</p>}
            {selectedMember.phone && <p><strong>Phone:</strong> {selectedMember.phone}</p>}
          </div>
        </div>
      )}

      <section style={{ marginTop: "3cm" }}>

        <div style={styles.searchWrapper}>
          <input
            type="text"
            placeholder="Search members by name, role or email..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={styles.searchInput}
          />
        </div>
        <div style={styles.page}>
          <h1 style={{ ...styles.name, fontSize: "36px" }}>Members</h1>

          <div style={styles.membersContainer}>

            {loading &&
              [...Array(8)].map((_, i) => (
                <div key={i} style={styles.card}>
                  <div className="skeleton" style={{ height: 280 }}></div>
                </div>
              ))
            }

            {!loading && members.map((m, index) => (
              <div key={index} style={styles.card}>

                <img
                  src={BACKEND_URL + m.picture}
                  alt={m.name}
                  onLoad={() =>
                    setLoadedImages((prev) => ({ ...prev, [index]: true }))
                  }
                  onClick={() => setSelectedMember(m)}
                  className={`lazy-img ${loadedImages[index] ? "loaded" : ""}`}
                  style={styles.image}
                />

                <h2>{m.name}</h2>
                <h3 style={{ color: "#777" }}>{m.position}</h3>

              </div>
            ))}

          </div>

          {/* PAGINATION */}
          <div style={styles.pagination}>
            <button onClick={() => goToPage(currentPage - 1)} disabled={currentPage === 1}>
              Prev
            </button>

            {[...Array(lastPage)].map((_, i) => (
              <button
                key={i}
                onClick={() => goToPage(i + 1)}
                style={{
                  fontWeight: currentPage === i + 1 ? "bold" : "normal"
                }}
              >
                {i + 1}
              </button>
            ))}

            <button onClick={() => goToPage(currentPage + 1)} disabled={currentPage === lastPage}>
              Next
            </button>
          </div>

        </div>
      </section>
    </>
  );
}

const styles = {
  searchWrapper: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    marginTop: "30px"
  },
  searchInput: {
    width: "90%",
    maxWidth: "600px",
    padding: "15px 20px",
    borderRadius: "50px",
    border: "none",
    outline: "none",
    fontSize: "16px",
    boxShadow: "0 8px 25px rgba(0,0,0,0.15)",
    background: "#fff",
    transition: "0.3s"
  },

  page: {
    width: "100%",
    minHeight: "100vh",
    padding: "50px 20px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  membersContainer: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "30px",
  },

  card: {
    width: "260px",
    background: "#fff",
    borderRadius: "20px",
    padding: "20px",
    textAlign: "center",
    boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
  },

  image: {
    width: "100%",
    height: "250px",
    objectFit: "cover",
    borderRadius: "20px",
  },

  pagination: {
    marginTop: "40px",
    display: "flex",
    gap: "10px"
  },

  overlay: {
    position: "fixed",
    width: "100%",
    height: "100vh",
    background: "rgba(0,0,0,0.85)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },

  modal: {
    background: "#fff",
    padding: "25px",
    borderRadius: "20px",
    width: "90%",
    maxWidth: "500px",
    textAlign: "center",
    position: "relative"
  },

  modalImg: {
    width: "100%",
    height: "300px",
    objectFit: "contain",
    borderRadius: "15px",
  },

  closeBtn: {
    position: "absolute",
    top: "10px",
    right: "15px",
    border: "none",
    background: "none",
    fontSize: "20px",
    cursor: "pointer"
  }
};